<template>
  <div>
    <div>
      <v-card class="card-shadow border-radius-xl pa-6">
        <div class="pb-4">
          <h6 class="text-typo text-h6 font-weight-bold">Place</h6>
        </div>
        <Loading v-if="loading"></Loading>
        <v-card-text v-else>
          <v-row>
            <v-col cols="6">
              <label class="text-xs text-typo font-weight-bolder ms-1"
                >NOM / NUMERO DE LA PLACE</label
              >
              <v-text-field
                v-model="spotName"
                hide-details
                outlined
                color="rgba(0,0,0,.6)"
                light
                placeholder=""
                class="
                  font-size-input
                  placeholder-lighter
                  border border-radius-md
                  text-light-input
                "
              ></v-text-field>
            </v-col>
            <v-col cols="6" class="d-flex align-center">
              <div class="mt-2">
                <label class="text-xs text-typo font-weight-bolder mr-4"
                  >RESERVABLE</label
                >
                <v-switch
                  :ripple="false"
                  class="d-inline-flex mt-0 pt-0 switch ms-auto"
                  v-model="isReservable"
                  hide-details
                  color="#3a416ff2"
                  inset
                ></v-switch>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <label class="text-xs text-typo font-weight-bolder ms-1"
                >TYPE DE PLACE</label
              >
              <v-select
                v-model="type"
                :items="typeList"
                item-text="name"
                item-value="id"
                hide-details
                multiple
                class="
                  input-style
                  font-size-input
                  text-light-input
                  placeholder-light
                  border-radius-md
                  select-style
                  mt-2
                "
                outlined
                single-line
                height="36"
              >
              </v-select>
            </v-col>
          </v-row>
          <div class="mb-4"></div>
          <!-- ATTRIBUTE SELECTOR TABLE -->
          <div>
            <SpotListFormAttributeTable
              :attributes="attributes"
              :spotAttributesToUpdate="spotToUpdate"
              @attrSelected="updateAttibuteRules"
            ></SpotListFormAttributeTable>
          </div>
          <div class="my-4"></div>
          <BtnBlue
            :btnTitle="editPlace ? $t('appButton.edit') : $t('appButton.save')"
            :disabled="canCreateSpot"
            @clicked="postPlace"
          ></BtnBlue>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import BtnBlue from "../common/BtnBlue.vue";
import SpotListFormAttributeTable from "./SpotListFormAttributeTable.vue";
import Loading from "../common/Loading.vue";

const VEHICLE_NAME_CONVERTER = {
  voiture: "car",
  moto: "moto",
  vélo: "bike",
  trottinette: "scooter",
  "mobilité douce": "soft",
};

export default {
  name: "SpotListForm",

  components: {
    BtnBlue,
    SpotListFormAttributeTable,
    Loading,
  },

  props: {
    attributes: {
      type: Array,
      required: true,
    },

    spotToUpdate: {
      type: [Object, null],
      default: null,
    },
  },

  data() {
    return {
      loading: false,
      editPlace: null,
      spotName: "",
      attributesRules: {},
      isReservable: true,
      type: [],
      typeList: ["voiture", "moto", "vélo", "trottinette", "mobilité douce"],
    };
  },

  created() {
    if (this.spotToUpdate) {
      this.spotName = this.spotToUpdate.name;
      this.isReservable = this.spotToUpdate.isReservable;
      if (this.spotToUpdate.type) {
        this.type = this.spotToUpdate.type.map(
          (elm) => this.keyValueSwitcher(VEHICLE_NAME_CONVERTER)[elm]
        );
      }
    }
  },

  computed: {
    canCreateSpot() {
      return this.spotName !== "";
    },
  },

  methods: {
    async postPlace() {
      const parkingid = this.$route.params.id;
      const data = {
        name: this.spotName.trim(),
        parkingid,
        isReservable: this.isReservable,
        ...(this.spotToUpdate ? { id: this.spotToUpdate.id } : {}),
        ...this.attributesRules,
        type: this.type.map((elm) => VEHICLE_NAME_CONVERTER[elm]),
      };
      this.loading = true;
      await this.$store.dispatch("post_spot", data);
      this.loading = false;
      this.$emit("closeDialog");
    },

    updateAttibuteRules(evt) {
      this.attributesRules = evt;
    },

    keyValueSwitcher(obj) {
      const objArr = Object.entries(obj);
      let switched = {};
      objArr.forEach((kv) => {
        switched[kv[1]] = kv[0];
      });
      return switched;
    },
  },
};
</script>

<style scoped></style>
